module.exports = __webpack_public_path__ + "static/media/wind_direction_timeseries.ef34dc7a.svg";